import validation, { getFailedValidations } from './validation';
import medicationDSS from './questionnaires/medication-dss';
import clinicalAssessment, {
} from './questionnaires/clinical-assessment';
import store from '../../store'

export const patientId = (state) => state.patientId || '';

export const version = (state) => state.version || '';

export const versionInt = (state) => state.version ? parseInt(state.version) : null;

export const bodyWeight = (state) => state.bodyWeight || '';

export const bloodPressureSystolic = (state) => state.bloodPressureSystolic || '';

export const bloodPressureDiastolic = (state) => state.bloodPressureDiastolic || '';

export const pulseRate = (state) => state.pulseRate || '';

export const LDL = (state) => state.LDL || '';

export const LDLInPreferredUnit = (state) => state.LDLInPreferredUnit || '';

export const eGFR = (state) => state.eGFR || '';

export const isWalkingTestPerformed = (state) => state.isWalkingTestPerformed;

export const notPerformedReasonGroup = (state) => state.notPerformedReasonGroup;

export const distanceWalked = (state) => state.distanceWalked || '';

export const numberOfAntiHypertensiveDrugs = (state) => state.currentAmountReceivedHypertensionDrugs;

export const meanBloodPressureAboveGoal = (state) => state.meanBloodPressureAboveGoal;

export const perceivedExertion = (state) => state.perceivedExertion || '';

export const notPerformedReason = (state) => state.notPerformedReason || '';

export const encounterConfigDisplayMedicationDSS = (state, getters ) => getters.getEncounterConfig('medicationDSS', 'display', getters.version)

export const encounterConfigDisplayClinicalAssessment = (state, getters ) => getters.getEncounterConfig('clinicalAssessment', 'display', getters.version);

import app from '../../app';

export const validationIssueObjects = (state, getters) => {
  const { isWalkingTestPerformed, versionInt } = getters;

  const walkingTestNotPerformedGroup = ['notPerformedReason', 'notPerformedReasonGroup'];
  const walkingTestPerformedGroup = ['distanceWalked', 'perceivedExertion'];
  const walkingTestDisabled = ![2, 6, 7].includes(versionInt)

  const allCAKeys = clinicalAssessment.map((item) => item.key);
  const displayedCAKeys = getters.encounterConfigDisplayClinicalAssessment.map((item) => item.key)

  const allMedKeys = medicationDSS.map((item) => item.key);
  const displayedMedKeys = getters.encounterConfigDisplayMedicationDSS.map((item) => item.key)

  return Object.keys(validation).reduce((accumulator, currentKey) => {
    if (
        // vital signs LDL/eGFR not necessary for any visit but 6
        (versionInt !== 6 && ['LDLInPreferredUnit', 'eGFR'].includes(currentKey)) ||
        // 6mwt only necessary for visits 2, 6, 7
        ((isWalkingTestPerformed || walkingTestDisabled) && walkingTestNotPerformedGroup.includes(currentKey)) ||
        (!isWalkingTestPerformed && walkingTestPerformedGroup.includes(currentKey)) ||
        (walkingTestDisabled && ['isWalkingTestPerformed'].includes(currentKey)) ||
        // Only validate questions that are displayed
        (allCAKeys.includes(currentKey) && !displayedCAKeys.includes(currentKey)) ||
        (allMedKeys.includes(currentKey) && !displayedMedKeys.includes(currentKey))
    ) {
      return accumulator;
    }

    const { rules } = validation[currentKey];
    const failed = getFailedValidations(rules, state[currentKey], store);

    return {
      ...accumulator,
      [currentKey]: failed.length ? rules[failed[0]] : null,
    };
  }, {});
};

export const validationIssues = (state, getters) => {
   const validationIssuesObjects = getters.validationIssueObjects, accumulator = {};

   for (let key in validationIssuesObjects){
     accumulator[key] = validationIssuesObjects[key] ? validationIssuesObjects[key].key : ""
   }

   return accumulator;
};

export const invalidFields = (state, getters) => {
  const keys = Object.keys(getters.validationIssues);

  return keys.reduce((accumulator, currentKey) => {
    if (getters.validationIssues[currentKey]) {
      return [...accumulator, currentKey];
    }
    return accumulator;
  }, []);
};

export const CHA2DS2VASCGenderIndependent = (state, getters) => {
  const gender = store.getters['patientSummary/gender'];
  let CHADsVASCScore = getters.versionInt < 6 ? state.CHA2DS2_VASC_V1 : state.CHA2DS2_VASC;

  CHADsVASCScore = CHADsVASCScore ? parseInt(CHADsVASCScore) : 0;

  if (CHADsVASCScore && gender && gender === 'female') CHADsVASCScore--

  return Math.max(CHADsVASCScore,0);
}

export const isValid = (state, getters) => {
  return !getters.invalidFields.length;
}

export const isValidationMode = (state) => state.isValidationMode;


export const getEncounterConfig = (state, getters, rootState, rootGetters) => (
    pageQuestion = 'clinicalAssessment',
    checkProperty = null,
    visit = null
) => {
  pageQuestion = pageQuestion.split('.');

  let [page, question] = pageQuestion;

  if (page === 'clinicalAssessment')
    page = clinicalAssessment
  else if( page === 'medicationDSS')
    page = medicationDSS
  else
    throw new Error('unknown page: ' + page)

  if (checkProperty === null) {
    if (question) {
      for (let i = 0; i < page.length; i++)
        if (page[i].key === question)
          return page[i]

      throw new Error('unknown question: ' + question)
    } else {
      return page;
    }
  }

  if (!['display', 'post'].includes(checkProperty)){
    throw new Error('unknown checkProperty: ' + checkProperty)
  }

  if (!visit) visit = getters.version

  if (question){
    for (let i = 0; i < page.length; i++)
      if (page[i].key === question)
        return page[i][checkProperty]({state, visit, config : page[i], getters, rootState, rootGetters})

    throw new Error('unknown question: ' + question)
  }else{
    return page.filter(config => {
      return config[checkProperty]({state, visit, config, getters, rootState, rootGetters})
    })
  }
}

export const getDSSReleaseForEncounter = (state, getters, rootState, rootGetters) => (visit) => {
  // Get the encounter model for the asked visit. If no specific visit is asked, get the currently opened visit.
  const encounter = rootGetters['patientSummary/getEncounter'](visit ? visit : getters.version);

  // Check if there was already an encounter for this visit, and if so use the used DSS version for that encounter
  // Otherwise use current dss release
  return encounter && encounter.DSSRelease ? encounter.DSSRelease : rootGetters.getServerInfo("dssRelease");
}

export const getDSSReleaseNumberForEncounter = (state, getters, rootState, rootGetters) => (visit) => {
  return parseInt(getters.getDSSReleaseForEncounter(visit).replace(/[^\d]/g, ''));
}

/**
 *
 * @param state
 * @param getters
 * @param rootState
 * @param rootGetters
 * @returns {(function(*): (string))|*}
 *
 * Try higher version keys first, eg for question key: INTOLERANCE_ASPIRIN, if the used DSS release is 3, try the following
 * keys in order:
 * questionnaires.DSS_INFO.questions.INTOLERANCE_ASPIRIN_V3.question , then
 * questionnaires.DSS_INFO.questions.INTOLERANCE_ASPIRIN_V2.question , finally
 * questionnaires.DSS_INFO.questions.INTOLERANCE_ASPIRIN.question
 *
 * This is done to reflect possible small changes in the wording of the questions over the DSS releases. Exceptions
 * can be programmed in this function since you have access to both the question key and the DSSReleaseNumber, but best
 * to let the translations follow the naming convention if possible.
 */
export const getTranslationForDSSQuestion = (state, getters, rootState, rootGetters) => (questionKey, language = null) => {
  let DSSReleaseNumber = getters.getDSSReleaseNumberForEncounter();
  const keyPrefix = 'questionnaires.DSS_INFO.questions.';
  const suffix = '.question';

  if (!language) {
    language = store.state.currentLanguage;
  }

  while (DSSReleaseNumber >= 2) {
    const translationKey = keyPrefix + questionKey + '_V' + DSSReleaseNumber + suffix;

    if (app.translationManager.translationExists(translationKey, 'questionnaires', language)){
      return app.translationManager.translate(translationKey, {catalog : 'questionnaires', language : language});
    }

    DSSReleaseNumber--;
  }

  return app.translationManager.translate(keyPrefix + questionKey + suffix, {catalog : 'questionnaires', language : language});
}
